module.exports = __webpack_public_path__ + "4b4e078f4c7a208fed4936c18f406413.svg";